import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/planning/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
